export enum SnsRecordStatus {
  Pending = 0,
  Accepted = 1,
  Rejected = 2,
  DeletePending = 3,
  DeleteAccepted = 4,
  DeleteRejected = 5,
}
